// Recovered compiled webpack factory 41556. Edit this function expression; run npm run build.
(e) => {
  e.exports = {
    style: {
      fontFamily: "'overusedGrotesk', 'overusedGrotesk Fallback', Geist, system-ui, sans-serif",
      fontStyle: "normal",
    },
    className: "__className_e0a542",
    variable: "__variable_e0a542",
  };
}
